import * as gfunctions from '../../../js/generalFunctions';

CCL.clpAddToCart = {
  autoload: [
    ['initialDataLoad', $('#clpAddToCartModal').length > 0],
    ['collapseStateroom', $('.collapsible-link').length > 0]
  ],

  initialDataLoad() {
    $('body').on('click', '.clp-add-to-cart-btn', (e) => {
      const dataObj = {
        productCode: $(e.currentTarget).data('productcode')
      };
      const pageType = $('#pagetype').data('pagetype');
      if (pageType === 'CATEGORY') {
        const productPosition = Number($(e.target).data('productposition')) + 1;
        const pageNumber = Number($(e.target).data('currentpage')) + 1;
        const categoryName = $(e.target).data('sascategorycode');
        localStorage.setItem('productposition', productPosition);
        localStorage.setItem('pageNumber', pageNumber);
        localStorage.setItem('sascategorycode', categoryName);
      }
      this.loadJsonData(dataObj);
    });
  },
  collapseStateroom() {
    $('.collapsible-link').click((e) => {
      $(e.currentTarget.parentElement.parentElement).find('.arrow-link img').toggleClass('time-conflict-img-rotate');
    });
  },
  loadJsonData(ajaxDataObj) {
    const token = $('#csrfSessionToken').data('csrf');
    let ajaxUrl = '';
    let ajaxType = '';
    if (window.location.hostname === 'localhost' && window.location.port === '6565') {
      ajaxUrl = '/json-data/clp-atc-modal.json';
      ajaxType = 'GET';
    } else {
      ajaxUrl = '/shop/cart/clp/modal';
      ajaxType = 'POST';
    }
    gfunctions.showLoader();
    $.ajax({
      type: ajaxType,
      url: ajaxUrl,
      contentType: 'application/json',
      headers: {
        CSRFToken: token
      },
      data: JSON.stringify(ajaxDataObj)
    }).done((response) => {
      if (response.productCard.variantPriceList) {
        const arr = [];
        $.each(response.productCard.variantPriceList, (i, value) => {
          const t = value.split('/');
          arr.push({ priceText: t[0], priceDesc: t[1] });
        });
        response.productCard.variantPriceListNew = arr;
      }

      // Checking for conflict error msgs
      let isConflictError;
      $.each(response.bookingInformation, (i, elem) => {
        if (elem.errorMessage) {
          isConflictError = true;
          return false;
        } else if (!elem.errorMessage) {
          $.each(elem.guestInformation, (j, guest) => {
            if (guest.errorText) {
              isConflictError = true;
              return false;
            }
            return true;
          });
        }
        return true;
      });
      response.isError = isConflictError;
      this.loadHtmlTamplate(response);
      gfunctions.hideLoader();
    }).fail(() => {
      gfunctions.hideLoader();
      console.log('error while fetching data');
    });
  },

  loadHtmlTamplate(jsonData) {
    gfunctions.showLoader();
    $.ajax({
      type: 'GET',
      url: '/_ui/responsive/ccl/assets/templates/clp-atc-modal/clp-atc.html'
    }).done((response) => {
      const html = gfunctions.createDynamicHTML(response, jsonData);
      $('#clpAddToCartModalContent').empty().append(html);
      gfunctions.showModal('clpAddToCartModal');
      gfunctions.pdpGetSelectedData();
      gfunctions.checkboxCheck();
      this.modalEvents();
      // wait for things to settle down
      /* This below code is added specailly for BB modal flow
         As we are opening this modal from boooking buddy modal scroll will not work on clp atc modal
         So to fix scroll below code will work
      */
      if ($('.modal:visible').length) {
        setTimeout(() => {
          $('body').addClass('modal-open');
        }, 500);
      }
      this.collapseStateroom();
      gfunctions.hideLoader();
    }).fail(() => {
      gfunctions.hideLoader();
      console.log('error while loading html');
    });
  },
  modalEvents() {
    const modalEl = $('#clpAddToCartModal');

    modalEl.find('button.close').on('keydown', (event) => {
      if ((event.keyCode === 9) && (event.shiftKey)) {
        event.preventDefault();
        const lastFocusable = gfunctions.getFocusableElements(modalEl, 'last');
        lastFocusable.focus();
      }
    });
    modalEl.find('.general-continue-shopping').on('keydown', (event) => {
      if ((event.keyCode === 9) && !(event.shiftKey)) {
        event.preventDefault();
        if (modalEl.find('.general-add-to-cart-btn:disabled').length > 0) {
          const firstFocusable = gfunctions.getFocusableElements(modalEl);
          firstFocusable.focus();
        } else {
          modalEl.find('.general-add-to-cart-btn').focus();
        }
      }
    });
    modalEl.find('.general-add-to-cart-btn').on('keydown', (event) => {
      if ((event.keyCode === 9) && !(event.shiftKey)) {
        event.preventDefault();
        const firstFocusable = gfunctions.getFocusableElements(modalEl);
        firstFocusable.focus();
      }
    });
  }
};



// WEBPACK FOOTER //
// ./src/app/components/c-clp-atc-modal/clp-atc-modal.js